const buildData = {
    gitHash: process.env.GIT_COMMIT || 'unknown',
    gitBranch: process.env.GIT_TAG || 'unknown',
    gitTag: process.env.GIT_TAG || 'unknown'
};
export { buildData };

//# sourceMappingURL=build-data.js.map